import React, { useEffect } from "react";
import SingleRoom from "./singleroom";
import BigRoom from "./bigroom";
import Stepper from "../../components/Stepper";

import { MatchContext } from "../../providers/match";

function Room(props) {
  const { getStatus } = props;
  const { roomSize, setNewContextRefresh, t, matchConfig } =
    React.useContext(MatchContext);

  useEffect(() => {
    //envia 1 novo estado, pra atualizar o provider do context
    setNewContextRefresh();

    return () => setNewContextRefresh();
  }, []);

  return (
    <div className="room-container-main">
      <Stepper
        currentStep={2}
        t={t}
        activeColor={matchConfig?.colorBackground}
      />
      {roomSize > 1 ? <BigRoom getStatus={getStatus} /> : <SingleRoom />}
    </div>
  );
}
export default Room;
